import type { FarmQuantificationUnit } from '@/types/apiModels'

export const groupQUsByYear = (
  qus: FarmQuantificationUnit[],
): Record<string, FarmQuantificationUnit[]> => {
  return qus.reduce<Record<string, FarmQuantificationUnit[]>>((acc, qu) => {
    const year = qu.improvementYear
    if (!acc[year]) {
      acc[year] = []
    }
    acc[year].push(qu)
    return acc
  }, {})
}
